import { request, qs } from './api';

// Feedback: list + delete. Real response is read-only content (no status/rating),
// so no create/edit/mark-reviewed. Fields are snake_case with nested user/itinerary.
export const listFeedback = (params) => request(`/feedback${qs(params)}`);
export const deleteFeedback = (id) => request(`/feedback/${id}`, { method: 'DELETE' });
